import { render, staticRenderFns } from "./ModalParticipants.vue?vue&type=template&id=65c9b40a&"
import script from "./ModalParticipants.vue?vue&type=script&lang=js&"
export * from "./ModalParticipants.vue?vue&type=script&lang=js&"
import style0 from "./ModalParticipants.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports